

































































import Vue from 'vue';
import ISO6391 from 'iso-639-1';
import { stringify } from 'querystring';
import vSelect from 'vue-select';

import { ReservationEntity, LocationEntity } from '../../../types';

export default Vue.extend({
  name: 'vue-header',
  components: {
    vSelect,
  },
  data() {
    return {
      logoOverride: null as string | null,
    };
  },
  methods: {
    getLanguageName(locale: string): string {
      // added code to add extra class on value seleted need to give width based on value selected
      
        setTimeout(()=>{
           document
          .querySelector(`
          #lang > #vs1__combobox 
          > .vs__selected-options 
          > .vs__selected`)?.classList
          .add(locale)
        },500)
    
      return ISO6391.getNativeName(locale);
    },
  },
  created() {
    this.$root.$on('setLogo', (logoURL: string) => {
      console.log('overriding logo', logoURL);
      this.logoOverride = logoURL;
    });
  },
  computed: {
    availableLanguages(): Array<{ code: string; name: string }> {
      return this.$root.$i18n.availableLocales
        .map((locale: string) => {
          return { code: locale, name: ISO6391.getNativeName(locale) };
        })
        .filter((availableLanguage) => availableLanguage.code !== this.$root.$i18n.locale);
    },
    logoSrc(): string {
      const locationsLogoURL =
        (this as any).locations && (this as any).locations[0] && (this as any).locations[0].logoURL ? (this as any).locations[0].logoURL : null;

      const externalUserReservationWithLogo = (this as any).externalUserReservations.find(
        (externalUserReservation: ReservationEntity) =>
          (externalUserReservation.location && externalUserReservation.location.logoURL) ||
          (externalUserReservation.locations && externalUserReservation.locations.find((location) => location.logoURL)),
      );

      const externalUserReservationsLocationLogoURL =
        externalUserReservationWithLogo && externalUserReservationWithLogo.locations
          ? externalUserReservationWithLogo.locations.find((location: LocationEntity) => location.logoURL).logoURL
          : externalUserReservationWithLogo
          ? externalUserReservationWithLogo.location.logoURL
          : null;

      const singleReservationLogoURL =
        (this as any).reservation && (this as any).reservation.location && (this as any).reservation.location.logoURL
          ? (this as any).reservation.location.logoURL
          : (this as any).reservation &&
            (this as any).reservation.locations &&
            (this as any).reservation.locations.find((location: LocationEntity) => location.logoURL)
          ? (this as any).reservation.locations.find((location: LocationEntity) => location.logoURL).logoURL
          : null;

      return this.logoOverride || locationsLogoURL || externalUserReservationsLocationLogoURL || singleReservationLogoURL || '/logo.svg';
    },
  },
});
